module.exports = __webpack_public_path__ + "img/left_img3.9cf2af1f.png";